import { theme } from 'antd'
import { antTheme } from '../theme/bioBridge'

// Breakpoint values come from antd's design tokens so JSS media queries share
// the same source of truth as the JS checks (Grid.useBreakpoint / useIsMobile).
const token = theme.getDesignToken(antTheme)

// Below antd's `md` breakpoint the app renders its mobile layout.
export const MOBILE_MEDIA_QUERY = `@media (max-width: ${token.screenSMMax}px)`
export const XL_MEDIA_QUERY = `@media (min-width: ${token.screenXLMin}px)`

// Tablet sits between the two: wide enough for a desktop layout to fit, not
// wide enough for it to breathe. iPad portrait and landscape are both inside.
export const TABLET_MEDIA_QUERY = `@media (min-width: ${token.screenMDMin}px) and (max-width: ${token.screenLGMax}px)`

// `Descriptions` decides its column count in JS, not CSS: a numeric `column={2}`
// is used at every breakpoint, so no media query can collapse it on a phone.
// Pass this instead — two columns from `md` up, one below, matching
// MOBILE_MEDIA_QUERY. `Descriptions.Item` resolves `span` the same way, so items
// that span the full row take this too (a raw `span={2}` against a 1-column
// layout renders fine but logs an antd dev warning).
export const DESCRIPTIONS_TWO_COLUMNS = {
  xs: 1,
  sm: 1,
  md: 2,
  lg: 2,
  xl: 2,
  xxl: 2,
}

export const DESCRIPTIONS_THREE_COLUMNS = {
  xs: 1,
  sm: 1,
  md: 3,
  lg: 3,
  xl: 3,
  xxl: 3,
}
